import './overview.css'
import {head, get} from 'lodash'
import React, {Component, useState} from 'react'
import {connect} from 'react-redux'
import {
  Table,
  Header,
  Icon,
  Form,
  Input,
  Checkbox,
  Pagination,
  Segment,
  Confirm,
  Dropdown,
  Image,
  Button,
  Label,
  Tab,
  Dimmer,
  Loader,
  Popup,
  TableHeaderCell
} from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import EditForm from './components/edit'
import NewForm from './components/new'
import CommentView from './components/commentview'
import Thumbnail from './components/thumbnail'
import LabelPanel from './components/labelpanel'
import RepeatRulePanel from './components/repeatrulepanel'
import FileUpload from './components/instance-file-upload'
import Empty from '../../../components/empty'
import PropTypes from 'prop-types'
import 'react-datepicker/dist/react-datepicker.css'
import {dateFormatter} from '../../../services/date-formatter'
import {dates} from '../../../constants'
import {
  getIssuesAction,
  endDateChangeAction,
  startDateChangeAction,
  deleteIssueAction,
  updateIssueStatus,
  updateIssueAction
} from '../../../actions/issues.action'
import {createAPIClient, createAWSClient} from '../../../services/api'
var PrintTemplate = require('react-print')
/* Use xlsx.js (CJS), not xlsx.mjs — webpack resolves "module" first and named ESM exports break XLSX.utils */
var XLSX = require('xlsx/xlsx.js')

const {DATE_SMALL, DATE_SMALL_v2} = dates
const {Field} = Form

const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

const LinkListing = ({items}) => {
  if (!items || !items.length) return null
  return (
    <Image.Group size='mini'>
      {items.map((item) => <Thumbnail src={item.url.replace('factori-upload','factori-upload-resized')} url={item.url} key={item._id} />)}
    </Image.Group>
  )
}

const TableHeaders = ({clickFunction, type, isCollapsed, title, item, icon}) => {
  const [style, setStyle] = useState({visibility: 'hidden', cursor: 'pointer'})
  const [customFieldText, setCustomFieldText] = useState({isShort: true})
  if (isCollapsed) {
    return <Table.HeaderCell onClick={clickFunction} style={{paddingTop: '0px', width: '10px',  cursor: 'pointer'}}>
      <Icon color={'grey'} name={'angle double right'} />
    </Table.HeaderCell>
  } else {
    switch (type) {
      case 'text':
        break
      case 'customfield':
        var displayValue = item.name
        var columnCategory = item.value_type
        switch (columnCategory) {
          case 'Picklist':
            columnCategory = 'Single select'
            break
          case 'TeamMember':
            columnCategory = 'Team member'
            break
        }
        if (displayValue.length < 25) {
          return (
            <Table.HeaderCell key={item.id} style={{minWidth: columnCategory === 'Text' ? '200px' : '150px'}}
                              onMouseEnter={e=> {setStyle({visibility: 'visible', cursor: 'pointer'})}}
                              onMouseLeave={e=> {setStyle({visibility: 'hidden', cursor: 'pointer'})}}
            >
              <React.Fragment>
                <p style={{marginBottom: '0px'}}>
                  <Icon title='Column visible on mobile.' name='mobile alternate' />
                  {displayValue}
                  <Icon onClick={clickFunction} style={style} color={'grey'} name={'angle double left'} />
                </p>
                <p style={{marginLeft: '20px', fontSize: 'smaller', color: '#929292', fontWeight: 'normal'}}>{columnCategory}</p>
              </React.Fragment>
            </Table.HeaderCell>
          )
        }
        if (customFieldText.isShort) {
          displayValue = typeof displayValue === 'string' && displayValue.substring(0, 25)
        }
        return (
          <Table.HeaderCell key={item.id} style={{minWidth: '150px'}}
                            onMouseEnter={e=> {setStyle({visibility: 'visible', cursor: 'pointer'})}}
                            onMouseLeave={e=> {setStyle({visibility: 'hidden', cursor: 'pointer'})}}
          >
            <React.Fragment>
              <p style={{marginBottom: '0px'}}>
                <Icon title='Column visible on mobile.' name='mobile alternate' />
                {displayValue}
                <a onClick={e => {setCustomFieldText({isShort: !customFieldText.isShort})}} href='#'>
                  {customFieldText.isShort ? ' ...' : ' Show less'}
                </a>
                <Icon onClick={clickFunction} style={style} color={'grey'} name={'angle double left'} />
              </p>
              <p style={{marginLeft: '20px', fontSize: 'smaller', color: '#929292', fontWeight: 'normal'}}>{columnCategory}</p>
            </React.Fragment>
          </Table.HeaderCell>
        )
      case 'attachment':
        return (
          <Table.HeaderCell style={{paddingTop: '0px'}}
                            onMouseEnter={e=> {setStyle({visibility: 'visible', cursor: 'pointer'})}}
                            onMouseLeave={e=> {setStyle({visibility: 'hidden', cursor: 'pointer'})}}
          >
            <Icon title='Column visible on mobile.' name='mobile alternate' />
            {title}
            <Icon onClick={clickFunction} style={style} color={'grey'} name={'angle double left'} />

          </Table.HeaderCell>
        )
      default:
        return (
          <Table.HeaderCell style={{paddingTop: '0px'}}
                            onMouseEnter={e=> {setStyle({visibility: 'visible', cursor: 'pointer'})}}
                            onMouseLeave={e=> {setStyle({visibility: 'hidden', cursor: 'pointer'})}}
          >
            {title}
            <Icon onClick={clickFunction} style={style} color={'grey'} name={'angle double left'} />
          </Table.HeaderCell>
        )
    }

  }
}

const TableCells = ({isCollapsed, item}) =>  {
  if (isCollapsed) {
    return (<Table.Cell />)
  } else {
    return item
  }
}



class IssuesOverview extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentTemplateId: this.props.params.templateId,
      // currentTemplateId: props.templates.length !== 0 ? props.templates[0].id : 0,
      searchTerm: undefined,
      isLoading: false,
      labels: [],
      timer: undefined,
      isEditing: false,
      newIncidentForm: false,
      filterLabelId: undefined,
      filterArchived: false,
      showFilter: false,
      syncTable: true,
      activePage: 1,
      totalPages: 0,
      itemsPerPage: 10,
      issueCount: 0,
      showLabelPanel: false,
      showRepeatRulePanel: false,
      firstIssueDate: moment().subtract(100, 'years').startOf('day'),
      selectedIssues: [],
      openConfirm: false,
      selectIssues: false,
      editingIssue: {
        isLoading: false,
        imageUploading: false,
        error: false,
        id: '',
        title: '',
        description: '',
        custom_field_values: {},
        attachments: []
      },
      filter: {
        column_type: 'created_at',
        startDate: undefined,
        endDate: undefined
      },
      commentView: {
        isOpen: false,
        location: undefined,
        issueId: undefined,
        commentId: undefined
      },
      columnCollapseStatus: {

      }
    }
  }
  toggleColumnStatus(columnId) {
    let newColumnState = Object.assign({}, this.state.columnCollapseStatus)
    newColumnState[columnId] = !newColumnState[columnId]
    this.setState({
      columnCollapseStatus: newColumnState
    })
  }
  // setTableHeaders () {
  //   let customFields = this.props.customFields
  //   let columnCollapseStatus = this.state.columnCollapseStatus
  //   for (let i = 0; i < customFields.length; i++) {
  //     if (!(customFields[i].id in columnCollapseStatus)) {
  //       columnCollapseStat
  //     }
  //   }
  // }


  loadData (startDate = this.props.startDate, endDate = this.props.endDate, page = this.state.activePage, templateId = this.state.currentTemplateId, labelId = this.state.filterLabelId, archived = this.state.filterArchived, searchTerm = this.state.searchTerm) {
    if (templateId === 0) {
      return
    }
    let filterParams = {
      template: templateId,
      label: labelId,
      archived: archived,
      term: searchTerm,
      limit: 400
    }
    filterParams[`custom-${this.state.filter.column_type}`] = JSON.stringify({
      end: this.state.filter.endDate ? moment(this.state.filter.endDate).endOf('day').toISOString() : undefined,
      start: this.state.filter.startDate ? moment(this.state.filter.startDate).startOf('day').toISOString() : undefined
    })

    this.setState({isLoading: true})
    this.props.getIssuesAction(filterParams, (count) => {
      this.setState({
        totalPages: Math.ceil(count / this.state.itemsPerPage),
        issueCount: count,
        isLoading: false
      })
    })
  }
  syncLoadData (startDate = this.props.startDate, endDate = this.props.endDate, page = this.state.activePage, templateId = this.state.currentTemplateId, labelId = this.state.filterLabelId, archived = this.state.filterArchived, searchTerm = undefined) {
    if (templateId === 0) {
      return
    }
    let filterParams = {
      template: templateId,
      label: labelId,
      archived: archived,
      term: searchTerm,
      limit: 400
    }
    filterParams[`custom-${this.state.filter.column_type}`] = JSON.stringify({
      end: this.state.filter.endDate ? moment(this.state.filter.endDate).endOf('day').toISOString() : undefined,
      start: this.state.filter.startDate ? moment(this.state.filter.startDate).startOf('day').toISOString() : undefined
    })
    this.props.getIssuesAction(filterParams, (count) => {
      this.setState({
        totalPages: Math.ceil(count / this.state.itemsPerPage),
        issueCount: count,
        isLoading: false
      })
    })
  }

  loadLabels () {
    const api = createAPIClient()
    api.get(`/api/labels?template=${this.state.currentTemplateId}`)
      .then(results => {
        this.setState({labels: results.data.response.items})
      })
      .catch(error => {
        console.log(error)
      })
  }

  getFirstIssueDate () {
    const api = createAPIClient()
    api.get('/api/issues?limit=400')
      .then(result => {
        if (result.data.response.items.length !== 0) {
          let date = moment(result.data.response.items[0].created_at)
          this.setState({
            firstIssueDate: date
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  componentDidMount () {
    const syncPeriod = 10000
    let searchTerm
    let self = this
    if (window.performance && window.performance.navigation.type === 1) {
      searchTerm = window.localStorage.getItem('searchTerm')
      this.setState({
        'searchTerm': searchTerm
      }, function () {
        self.loadData()
      })
    } else {
      this.loadData()
    }
    this.loadLabels()
    let timer = setInterval(this.syncTable.bind(this), syncPeriod)
    this.setState({timer: timer})
    this.getFirstIssueDate()

  }

  componentWillUnmount () {
    let timer = this.state.timer
    this.setState({timer: undefined})
    clearInterval(timer)
  }

  componentWillUpdate (nextProps) {
    if (this.props.templates.length === 0 && nextProps.templates.length !== 0) {
      this.setState({currentTemplateId: nextProps.templates[0].id})
      this.loadData(this.props.startDate, this.props.endDate, this.state.activePage, nextProps.templates[0].id)
    }
    if (this.props.params.templateId !== nextProps.params.templateId) {
      this.setState({currentTemplateId: nextProps.params.templateId, activePage: 1})
      this.loadData(this.props.startDate, this.props.endDate, 1, nextProps.params.templateId)
    }
    if (nextProps.shouldUpdate) {
      this.loadData()
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.state.currentTemplateId !== prevState.currentTemplateId) {
      this.loadLabels()
    }
  }

  handleFilterDateChange (filterParam, date) {
    let filter = Object.assign({}, this.state.filter)
    filter[filterParam] = date
    this.setState({filter: filter}, this.loadData)
  }
  clearFilter () {
    let filter = {
      column_type: 'created_at',
      startDate: undefined,
      endDate: undefined
    }
    this.setState({filter: filter}, this.loadData)
  }

  handleChangeEnd (date) {
    date.endOf('day')
    this.props.endDateChangeAction(date)
    this.loadData(this.props.staratDate, date, this.props.activePage)
  }

  async handlePageChange (e, data) {
    await this.setState({activePage: data.activePage})
  }

  updateIssue (id, form) {
    this.props.updateIssueStatus(id, form)
  }

  syncTable () {
    if (this.state.syncTable) { // stop syncing if user editing something
      this.syncLoadData(this.props.startDate, this.props.endDate, this.state.activePage, this.state.currentTemplateId, this.state.filterLabelId, this.state.filterArchived, this.state.searchTerm)
    }
  }

  // Edit issue on overview table
  onEdit (id) {
    let selectedIssue = {}
    for (let i = 0; i < this.props.issues.length; i++) {
      if (this.props.issues[i].id === id) {
        selectedIssue = this.props.issues[i]
        break
      }
    }
    const editingIssue = Object.assign({}, this.state.editingIssue, {
      id: selectedIssue.id,
      title: selectedIssue.title,
      label: selectedIssue.label,
      description: selectedIssue.description ? selectedIssue.description : '',
      custom_field_values: {},
      attachments: selectedIssue.attachments,
      archived: selectedIssue.archived
    })

    for (let i = 0; i < this.props.customFields.length; i++) {
      const customField = this.props.customFields[i]
      editingIssue.custom_field_values[customField.id] = {value: '', custom_field: customField.id}
    }

    for (let i = 0; i < selectedIssue.custom_field_values.length; i++) {
      const customFieldValue = selectedIssue.custom_field_values[i]
      editingIssue.custom_field_values[customFieldValue.custom_field] = customFieldValue
    }
    this.setState({isEditing: true, editingIssue: editingIssue})
  }

  cancelEdit () {
    this.setState({isEditing: false})
  }

  onChange (e) {
    const targetName = e.target.name
    const targetValue = e.target.value
    if (targetName === 'title' || targetName === 'description' || targetName === 'label') {
      const updatedEditingIssue = Object.assign({}, this.state.editingIssue, {
        [targetName]: targetValue ? targetValue : null
      })
      this.setState({
        editingIssue: updatedEditingIssue
      })
    } else {
      const updatedEditingIssue = Object.assign({}, this.state.editingIssue)
      updatedEditingIssue.custom_field_values[targetName] = {value: targetValue, custom_field: targetName}
      this.setState({
        editingIssue: updatedEditingIssue
      })
    }
  }

  arrayToCSV (twoDiArray) {
    const csvRows = []
    for (let i = 0; i < twoDiArray.length; ++i) {
      for (let j = 0; j < twoDiArray[i].length; ++j) {
        twoDiArray[i][j] = '"' + twoDiArray[i][j] + '"'  // Handle elements that contain commas
      }
      csvRows.push(twoDiArray[i].join(','))
    }
    const csvString = csvRows.join('\r\n')
    this.download('issue_overview_table.csv', csvString)
  }

  downloadBlob (filename, blob) {
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      var link = document.createElement('a')
      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    }
  }

  download (filename, rows) {
    var blob = new Blob([rows], {type: 'text/csv;charset=utf-8;'})
    this.downloadBlob(filename, blob)
  }

  async filterButtonClick () {
    if (!this.state.showFilter) {
      // this.handleChangeStart(this.state.firstIssueDate)
    } else {
      await this.setState({filterLabelId: undefined})
      // this.handleChangeStart(moment().subtract(100, 'years'))
    }
    this.setState({showFilter: !this.state.showFilter})
  }

  buildIssueExportRows () {
    const {issues, customFields} = this.props
    let headers = ['Label']
    for (let i = 0; i < customFields.length; i++) {
      headers.push(customFields[i].name)
    }
    headers = headers.concat(['Attachments', 'Reported'])

    let body = [headers]
    for (let i = 0; i < issues.length; i++) {
      const issue = issues[i]
      const values = get(issue, 'custom_field_values')
      const customValues = customFields
        .map(cf => head(values.filter(value => value.custom_field === cf.id).map(row => {
          return {value: get(row, 'value'), id: get(row, '_id')}
        })))
      let row = [issue.label ? issue.label.name : '']
      for (let j = 0; j < customValues.length; j++) {
        row.push(customValues[j] && customValues[j].value)
      }
      let attachmentStr = ''
      for (let j = 0; j < issue.attachments.length; j++) {
        attachmentStr += issue.attachments[j].url + ' , '
      }
      row.push(attachmentStr)
      row.push(dateFormatter(issue.created_at, null, DATE_SMALL) + (issue.accesstoken ? ' | ' + issue.accesstoken.info + ' | ' + issue.accesstoken.owner : ''))
      row = row.map(function (item) {
        return item === undefined ? '' : item
      })

      body.push(row)
    }
    return body
  }

  exportCsv () {
    this.arrayToCSV(this.buildIssueExportRows())
  }

  exportExcel () {
    const rows = this.buildIssueExportRows()
    const ws = XLSX.utils.aoa_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Issues')
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    this.downloadBlob('issue_overview_table.xlsx', blob)
  }
  exportPdf () {
    window.print()
    return true;
  }

  showLabelPanel () {
    this.setState({showLabelPanel: !this.state.showLabelPanel})
  }
  showRepeatRulePanel () {
    this.setState({showRepeatRulePanel: !this.state.showRepeatRulePanel})
  }

  handleTabChange (e, {activeIndex}) {
    this.setState({currentTemplateId: this.props.templates[activeIndex].id, activePage: 1, totalPages: 0})
    this.loadData(this.props.startDate, this.props.endDate, this.state.activePage, this.props.templates[activeIndex].id)
  }
  async onFilterTypeChange (e, {value}) {
    let currentFilter = this.state.filter
    currentFilter = Object.assign({}, currentFilter, {
      column_type: value
    })
    const self = this
    this.setState({filter: currentFilter}, function () {
      self.loadData()
    })
  }
  async onLabelFilterChange (e, {value}) {
    await this.setState({filterLabelId: value})
    this.loadData(this.props.startDate, this.props.endDate, this.state.activePage, this.state.currentTemplateId, value)
  }
  async onArchiveFilterChange (e, {checked}) {
    await this.setState({filterArchived: checked})
    this.loadData(this.props.startDate, this.props.endDate, this.state.activePage, this.state.currentTemplateId, this.state.filterLabelId, checked)

  }
  searchButtonClick () {
    let self = this
    this.setState({searchTerm: undefined}, function () {
      window.localStorage.removeItem('searchTerm')
      self.loadData()
    })
  }
  onSearchFieldChange (e) {
    const self = this
    let val = e.target.value
    if (val !== '') {
      this.setState({searchTerm: val}, function () {
        window.localStorage.setItem('searchTerm', val)
        self.loadData()
      })
    } else {
      this.setState({searchTerm: undefined}, function () {
        window.localStorage.removeItem('searchTerm')
        self.loadData()
      })
    }
  }
  onSearchKeyPress (e) {
    if (e.key === 'Enter') {
      window.localStorage.setItem('searchTerm', this.state.searchTerm)
      this.loadData(this.props.startDate, this.props.endDate, this.state.activePage, this.state.currentTemplateId, this.state.filterLabelId, this.state.filterArchived, this.state.searchTerm)
    }
  }
  deleteSelection () {
    var selectedIssues = this.state.selectedIssues
    const api = createAPIClient()
    api.delete(`/api/private/frontend/bulk-delete`, { data: { selectedIssues: selectedIssues } })
      .then(result => {
        this.loadData()
        this.setState({
          activePage: 1,
          selectedIssues: []
        })
        this.onSelectionIconClick()
      })
      .catch(error => {
        console.log(error)
      })
  }
  onIssueSelectionChange (id, e, data) {
    var selectedIssues = this.state.selectedIssues
    if (data.checked) {
      selectedIssues.push(id)
    } else {
      var index = selectedIssues.indexOf(id)
      if (index > -1) {
        selectedIssues.splice(index, 1)
      }
    }
    this.setState({selectedIssues: selectedIssues})
  }
  onSelectionIconClick () {
    var flag = this.state.selectIssues
    this.setState({
      selectIssues: !flag
    })
    if (!flag) {
      this.setState({
        selectedIssues: []
      })
    }
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    this.deleteSelection()
    this.setState({openConfirm: false})
  }
  showCommentView (issue) {
    let commentView = {
      issueId: issue._id,
      commentId: issue.comments && issue.comments._id,
      isOpen: true
    }
    this.setState({commentView: commentView})
  }
  render () {
    if (!this.props.params.templateId) {
      return (
        <Dimmer active={this.state.isLoading} inverted>
          <Loader />
        </Dimmer>)
    }
    // const marginBottom = {marginBottom: '3rem', overflow: 'hidden', overflowX: 'scroll', overflowY: 'scroll', height: '650px'}
    const marginBottom = {marginBottom: '3rem', overflow: 'hidden', overflowX: 'scroll'}
    const {issues, customFields} = this.props
    const hasContent = issues && issues.length
    const showPagination = this.state.totalPages > 1
    const currentTemplate = this.props.templates.filter((temp) => {
      return temp.id === this.state.currentTemplateId
    })[0]
    const optionMenu = (
      <div>
        <Button onClick={this.newIncidentButtonClick.bind(this)} type='button'>New record</Button>
        <Button secondary={this.state.showFilter} onClick={this.filterButtonClick.bind(this)} type='button'>Filter</Button>
        <Button secondary={this.state.showLabelPanel} onClick={this.showLabelPanel.bind(this)} type='button'>Labels</Button>
        <Button secondary={this.state.showRepeatRulePanel} onClick={this.showRepeatRulePanel.bind(this)} type='button'>Repeat rules</Button>
        <Dropdown id={'downloadMenu'} text='Download as' floating button className='icon'>
          <Dropdown.Menu>
            <Dropdown.Item onClick={this.exportCsv.bind(this)} >CSV</Dropdown.Item>
            <Dropdown.Item onClick={this.exportExcel.bind(this)}>Excel</Dropdown.Item>
            <Dropdown.Item onClick={this.exportPdf.bind(this)}>PDF</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button onClick={this.showConfirm.bind(this)} type='button' disabled={this.state.selectedIssues.length < 1}>Delete selection</Button>
        <Input style={{position: 'absolute', right: '0', width: '20%', marginRight: '10px'}}
          icon={{ name: this.state.searchTerm ? 'close' : 'search', circular: true, link: true, onClick: this.searchButtonClick.bind(this) }} placeholder='Search ...'
          value={this.state.searchTerm?this.state.searchTerm: ''}
          onChange={this.onSearchFieldChange.bind(this)}
          onKeyPress={this.onSearchKeyPress.bind(this)}
        />
        <style>
          {`
          #downloadMenu > i {
            padding-left: 10px;
            padding-top: 2px;
          }

          `
          }
        </style>
      </div>
    )
    const dateFilters = (<Segment padded>
      <Form style={{margin: '10px'}}>
        <Form.Field inline>
          <label>Column</label>
          <Dropdown
            onChange={this.onFilterTypeChange.bind(this)}
            defaultValue={'created_at'}
            selection
            options={
              [
                { key: 'Created at', text: 'Created', value: 'created_at' },
                { key: 'Uploaded at', text: 'Uploaded', value: 'reported_at' }
              ].concat(
                customFields.filter(e => e.value_type === 'Calendar').map(item => {
                  return {
                    key: item.id,
                    text: item.name,
                    value: item.id
                  }
                }))
            }
          />
        </Form.Field>
        <Form.Field inline>
          <label style={{marginRight: '25px'}}>From </label>
          <DatePicker
            // selected={this.state.filter.startDate && moment(this.state.filter.startDate).toDate()}
            selected={this.state.filter.startDate && moment(this.state.filter.startDate).toDate()}
            onSelect={this.handleFilterDateChange.bind(this, 'startDate')}
            dateFormat="dd/MM/yyyy"
          />
        </Form.Field>

        <Form.Field inline>
          <label style={{marginRight: '25px'}}>Until </label>

          <DatePicker
            // selected={this.state.filter.startDate && moment(this.state.filter.startDate).toDate()}
            selected={this.state.filter.endDate && moment(this.state.filter.endDate).toDate()}
            onSelect={this.handleFilterDateChange.bind(this, 'endDate')}
            dateFormat="dd/MM/yyyy"
          />
        </Form.Field>
        <Button onClick={this.clearFilter.bind(this)}>Clear</Button>
      </Form>
    </Segment>)
    let labelFilterOptions = this.state.labels.map(label => {
      return {
        key: label.id,
        text: label.name,
        value: label.id,
        label: {color: label.color, empty: true, circular: true}
      }
    })

    labelFilterOptions.unshift({text: 'Select label', value: undefined, key: 0})
    const labelFilters = (
      <Segment padded>
        <Form style={{margin: '10px'}}>
          <Field inline>
            <label>Label</label>
            <Dropdown placeholder='Select label' selection options={labelFilterOptions}
                      onChange={this.onLabelFilterChange.bind(this)} defaultValue={labelFilterOptions[0].value}/>
          </Field>
        </Form>
      </Segment>
    )

    const archivedIssuesFilter = (
      <Segment padded>
        <Form style={{margin: '10px'}}>
          <Field inline>
            <Checkbox label='Archived issues' onChange={this.onArchiveFilterChange.bind(this)} />
          </Field>
        </Form>
      </Segment>
    )

    const tableRows = (
      <Table.Body>
        {issues.slice((this.state.activePage - 1) * 10, (this.state.activePage - 1) * 10 + 10).map((issue, issueIndex) => {
          const values = get(issue, 'custom_field_values')
          const customValues = customFields
            .map(cf => head(values.filter(value => value.custom_field === cf.id).map(row => {
              return {value: get(row, 'value'), id: get(row, '_id'), keyValue: cf.id + get(row, '_id'), cfId: cf.id, type: cf.value_type}
            })))
          return (
            <Table.Row key={issue.id}>
              <Table.Cell>
                {
                  !this.state.selectIssues ? (<a href='#'>
                    {issue.label ? <Label color={issue.label.color} style={{
                      height: '40px',
                      width: '5px',
                      float: 'left',
                      margin: '0px',
                      padding: '0px'
                    }} /> : undefined}

                    <Image style={{margin: '0px', padding: '0px', marginLeft: '5px', marginTop: '7px'}}
                      onClick={this.onEdit.bind(this, issue.id)} avatar src={'/icons/expand_1369826.svg'} />
                  </a>)
                    : (<Checkbox style={{margin: '0px', padding: '0px', marginLeft: '12px', marginTop: '15px'}}
                      defaultChecked={this.state.selectedIssues.indexOf(issue.id) > -1} onChange={this.onIssueSelectionChange.bind(this, issue.id)} />)
                }
              </Table.Cell>
              <Table.Cell>{issueIndex + 1 + ((this.state.activePage - 1) * 10)}</Table.Cell>
              <TableCells isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'uploaded']}  item={
                <Table.Cell>{dateFormatter(issue.reported_at, null, DATE_SMALL_v2)}</Table.Cell>
              }/>
              <TableCells isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'created']}  item={
                <Table.Cell>{dateFormatter(issue.created_at, null, DATE_SMALL_v2)}</Table.Cell>
              }/>


              {customValues.map((val, index) => {
                  if (!val) {
                    return (
                      <Table.Cell key={index}>
                      </Table.Cell>
                    )
                  } else if (val.type === 'TeamMember') {
                    var outputText = []
                    var relevantMembers = currentTemplate.all_users
                      .filter(assignee => val.value.indexOf(assignee.id) !== -1)
                    for (var i = 0; i < relevantMembers.length; i++) {
                      outputText.push(relevantMembers[i].first_name + ' ' + relevantMembers[i].last_name)
                    }
                    return (
                      <TableCells isCollapsed={this.state.columnCollapseStatus[val.cfId]}  item={
                        <Table.Cell key={index}>
                          <PopupText textValue={outputText.join(', ')} />
                        </Table.Cell>
                      }/>
                    )
                  } else if (val.type === 'Calendar') {
                    return (
                      <TableCells isCollapsed={this.state.columnCollapseStatus[val.cfId]}  item={
                        <Table.Cell key={index}>
                          <PopupText textValue={val && moment(val.value).format('DD/MM/YYYY HH:mm')} />
                        </Table.Cell>
                      }/>
                    )
                  } else {
                    return (
                      <TableCells isCollapsed={this.state.columnCollapseStatus[val.cfId]}  item={
                        <Table.Cell key={index}>
                          <PopupText strLimit={50} textValue={val.value} />
                        </Table.Cell>
                      }/>
                    )
                  }
                }
              )}
              <TableCells isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'attachment']}  item={
                <Table.Cell>
                  {/*<LinkListing items={issue && issue.attachments} />*/}
                  <Image.Group size='mini'>
                    {issue && issue.attachments && issue.attachments.map((item, index) => <Thumbnail src={item.url.replace('factori-upload','factori-upload-resized')} url={item.url} key={item._id}/>)}
                    <FileUpload issue={issue} updateIssueAction={this.props.updateIssueAction} />

                  </Image.Group>
                </Table.Cell>
              }/>

              <TableCells isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'device']}  item={
                <Table.Cell>{issue.accesstoken ? issue.accesstoken.info + ' | ' + issue.accesstoken.owner : 'Browser'}</Table.Cell>
              }/>
              <TableCells isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'comments']}  item={
                <Table.Cell>
                  <CommentText issue={issue} handleClick={this.showCommentView.bind(this, issue)} />
                </Table.Cell>
              }/>
            </Table.Row>
          )
        })}
      </Table.Body>
    )
    const pagination = (<Pagination
      activePage={this.state.activePage}
      boundaryRange={1}
      size='mini'
      siblingRange={1}
      totalPages={this.state.totalPages}
      onPageChange={this.handlePageChange.bind(this)}
    />)
    const table = (<Table celled singleLine unstackable >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{width: '60px'}} >
            <a href='#'>
              <Icon style={{marginLeft: '10px'}} name={this.state.selectIssues ? 'cancel' : 'pencil alternate'} onClick={this.onSelectionIconClick.bind(this)} />
            </a>
          </Table.HeaderCell>
          <Table.HeaderCell style={{width: '60px', paddingTop: '0px'}}>Number</Table.HeaderCell>
          <TableHeaders clickFunction={this.toggleColumnStatus.bind(this, this.state.currentTemplateId + 'uploaded')} title={'Uploaded'}  isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'uploaded']} />
          <TableHeaders clickFunction={this.toggleColumnStatus.bind(this, this.state.currentTemplateId + 'created')} title={'Created'}  isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'created']} />
          {customFields.map(item =>
            <TableHeaders item={item} type={'customfield'} clickFunction={this.toggleColumnStatus.bind(this, item.id)}
                          isCollapsed={this.state.columnCollapseStatus[item.id]}/>
          )}
          <TableHeaders type={'attachment'} clickFunction={this.toggleColumnStatus.bind(this, this.state.currentTemplateId + 'attachment')} title={'Attachments'}  isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'attachment']} />
          <TableHeaders clickFunction={this.toggleColumnStatus.bind(this, this.state.currentTemplateId + 'device')} title={'Device'}  isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'device']} />
          <TableHeaders clickFunction={this.toggleColumnStatus.bind(this, this.state.currentTemplateId + 'comments')} title={'Comments'}  isCollapsed={this.state.columnCollapseStatus[this.state.currentTemplateId + 'comments']} />
        </Table.Row>
      </Table.Header>

      {tableRows}
    </Table>)
    const printableTableRows = (
      <Table.Body>
        {issues.map((issue, issueIndex) => {
          const values = get(issue, 'custom_field_values')
          const customValues = customFields
            .map(cf => head(values.filter(value => value.custom_field === cf.id).map(row => {
              return {value: get(row, 'value'), id: get(row, '_id'), keyValue: cf.id + get(row, '_id'), type: cf.value_type}
            })))
          return (
            <Table.Row key={issue.id}>
              <Table.Cell>
                {
                  !this.state.selectIssues ? (<a href='#'>
                      {issue.label ? <Label color={issue.label.color} style={{
                        height: '40px',
                        width: '5px',
                        float: 'left',
                        margin: '0px',
                        padding: '0px'
                      }} /> : undefined}

                      <Image style={{margin: '0px', padding: '0px', marginLeft: '5px', marginTop: '7px'}}
                             onClick={this.onEdit.bind(this, issue.id)} avatar src={'/icons/expand_1369826.svg'} />
                    </a>)
                    : (<Checkbox style={{margin: '0px', padding: '0px', marginLeft: '12px', marginTop: '15px'}}
                                 defaultChecked={this.state.selectedIssues.indexOf(issue.id) > -1} onChange={this.onIssueSelectionChange.bind(this, issue.id)} />)
                }
              </Table.Cell>
              <Table.Cell>{issueIndex+1}</Table.Cell>
              <Table.Cell>{dateFormatter(issue.reported_at, null, DATE_SMALL)}</Table.Cell>
              <Table.Cell>{dateFormatter(issue.created_at, null, DATE_SMALL)}</Table.Cell>
              {customValues.map((val, index) => {
                  if (!val) {
                    return (
                      <Table.Cell key={index}>
                      </Table.Cell>
                    )
                  } else if (val.type === 'TeamMember') {
                    var outputText = []
                    var relevantMembers = currentTemplate.assignees
                      .filter(assignee => val.value.indexOf(assignee.id) !== -1)
                    for (var i = 0; i < relevantMembers.length; i++) {
                      outputText.push(relevantMembers[i].first_name + ' ' + relevantMembers[i].last_name)
                    }
                    return (
                      <Table.Cell key={index}>
                        <ShortText textValue={outputText.join(', ')} />
                      </Table.Cell>
                    )
                  } else if (val.type === 'Calendar') {
                    return (
                      <Table.Cell key={index}>
                        <ShortText textValue={val && moment(val.value).format('DD/MM/YYYY')} />
                      </Table.Cell>
                    )
                  } else {
                    return (
                      <Table.Cell key={index}>
                        <ShortText textValue={val.value} />
                      </Table.Cell>
                    )
                  }
                }
              )}
              <Table.Cell>
                <LinkListing items={issue && issue.attachments} />
              </Table.Cell>
              <Table.Cell>{issue.accesstoken ? issue.accesstoken.info + ' | ' + issue.accesstoken.owner : 'Browser'}</Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )
    const printableTable = (<Table celled singleLine unstackable >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{width: '60px'}} >
            <a href='#'>
              <Icon style={{marginLeft: '10px'}} name={this.state.selectIssues ? 'cancel' : 'pencil alternate'} onClick={this.onSelectionIconClick.bind(this)} />
            </a>
          </Table.HeaderCell>
          <Table.HeaderCell style={{width: '60px'}}>Number</Table.HeaderCell>
          <Table.HeaderCell>Uploaded</Table.HeaderCell>
          <Table.HeaderCell>Created</Table.HeaderCell>
          {customFields.map(item => <Table.HeaderCell key={item.id} style={{minWidth: '150px'}}><ShortText
            textValue={item.name} /></Table.HeaderCell>)}
          <Table.HeaderCell>Attachments</Table.HeaderCell>
          <Table.HeaderCell>Device</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      {printableTableRows}
    </Table>)
    const _self = this
    const output = (
      <div>
        <div id='react-no-print'>

          <div style={{marginBottom: '3rem'}}>
            <div>{optionMenu}</div>
            {this.state.showFilter ? dateFilters : null}
            {this.state.showFilter ? labelFilters : null}
            {this.state.showFilter ? archivedIssuesFilter : null}
            {this.state.showLabelPanel ? <LabelPanel loadLabels={this.loadLabels.bind(this)} templateId={this.state.currentTemplateId} /> : null}
            {this.state.showRepeatRulePanel ? <RepeatRulePanel loadLabels={this.loadLabels.bind(this)} templateId={this.state.currentTemplateId} customFields={customFields} labels={this.state.labels} /> : null}
          </div>
          <div className='dimmable' style={marginBottom}>
            <Dimmer active={this.state.isLoading} inverted>
              <Loader />
            </Dimmer>
            {hasContent ? table : (<Empty>No issues.</Empty>)}
          </div>
          <div>
            {showPagination ? pagination : undefined}
          </div>
          <EditForm
            customFields={customFields}
            labels={this.state.labels}
            editingIssue={this.state.editingIssue}
            isEditing={this.state.isEditing}
            cancelEdit={this.cancelEdit.bind(this)}
            templateId={this.state.currentTemplateId}
          />
          <NewForm
            openNewIssue={this.state.newIncidentForm}
            cancelNewIssue={this.cancelNewIssue.bind(this)}
            labels={this.state.labels}
            customFields={customFields}
            currentTemplateId={this.state.currentTemplateId}
            templateId={this.state.currentTemplateId}
          />
          <CommentView
            isOpen={this.state.commentView.isOpen}
            location={currentTemplate.location}
            issueId={this.state.commentView.issueId}
            commentId={this.state.commentView.commentId}
            onClose={function () {
              let commentView = {
                isOpen: false,
                location: undefined,
                issueId: undefined,
                commentId: undefined
              }
              _self.setState({commentView: commentView})
            }}
          />
          <Confirm
            style={confirmStyle}
            open={this.state.openConfirm}
            onCancel={this.handleCancel.bind(this)}
            onConfirm={this.handleConfirm.bind(this)}
            content={`Are you sure you want to delete ${this.state.selectedIssues.length} records?`}
            confirmButton='Yes'
          />
        </div>
        <PrintTemplate>
          {hasContent ? printableTable : (<Empty>No issues.</Empty>)}
        </PrintTemplate>
      </div>
    )
    // const lockedOutput = (
    //   <div>
    //     <Header as='h2' icon textAlign='center'>
    //       <Icon name='lock' />
    //       Account Settings
    //       <Header.Subheader>Pleas update your account to access multiple templates</Header.Subheader>
    //     </Header>t
    //   </div>
    // )
    // const panes = this.props.templates.map(template => {
    //   if (template.is_active) {
    //     return {menuItem: template.name, render: () => <Tab.Pane>{output}</Tab.Pane>}
    //   } else {
    //     return {
    //       menuItem: {key: template.name, content: template.name, icon: 'lock'},
    //       render: () => <Tab.Pane>{lockedOutput}</Tab.Pane>}
    //   }
    // })
    // const tabPane = (
    //   <Tab panes={panes} onTabChange={this.handleTabChange.bind(this)} />
    // )
    return output
  }
  cancelNewIssue () {
    this.setState({
      newIncidentForm: false
    })
  }
  newIncidentButtonClick () {
    this.setState({
      newIncidentForm: true
    })
  }


}

// custom input for date picker
class DateInputField extends Component {
  render () {
    const {label, value, onClick} = this.props
    return (
      <Form style={{margin: '10px'}}>
        <Field inline>
          {label ? <label>{label}</label> : null}
          <Input style={{marginLeft: '22px'}} value={value} onClick={onClick}/>
        </Field>
      </Form>
    )
  }
}

class PopupText extends Component {
  render () {
    let strLimit = this.props.strLimit || 25
    var displayValue = this.props.textValue
    if (displayValue === undefined || displayValue === '') {
      return (<p />)
    }
    if (displayValue.length < strLimit) {
      return (
        <p>{this.props.icon}{displayValue}</p>
      )
    } else {
      let shortValue = typeof displayValue === 'string' && displayValue.substring(0, strLimit)
      return (
        <p>{shortValue} <Popup basic wide='very' on='click' content={displayValue} trigger={<span style={{cursor: 'pointer', color: 'blue'}}>...</span>} /></p>
      )
    }
  }
}

class ShortText extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isShort: true
    }
  }

  onClickAction () {
    this.setState({
      isShort: !this.state.isShort
    })
  }

  render () {
    var displayValue = this.props.textValue
    if (displayValue === undefined || displayValue === '') {
      return (<p/>)
    }
    if (displayValue.length < 25) {
      return (
        <p>{this.props.icon}{displayValue}</p>
      )
    }
    if (this.state.isShort) {
      displayValue = typeof displayValue === 'string' && displayValue.substring(0, 25)
    }
    return (
      <p>{this.props.icon}{displayValue}<a onClick={this.onClickAction.bind(this)}
                          href='#'>{this.state.isShort ? ' ...' : ' Show less'}</a></p>
    )
  }
}


class CommentText extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isShort: true
    }
  }

  onClickAction () {
    this.setState({
      isShort: !this.state.isShort
    })
  }

  render () {
    let issue = this.props.issue
    if (issue && issue.comments && issue.comments.messages && issue.comments.messages.length > 0) {
      let lastMessage = issue.comments.messages[issue.comments.messages.length - 1].text
      let displayValue = typeof lastMessage === 'string' && lastMessage.substring(0, 25)
      return (
        <p>{displayValue}<a href='#' onClick={this.props.handleClick}>... Show more</a></p>
      )
    } else {
      return (<a href='#' onClick={this.props.handleClick}>Show comments</a>)
    }
  }
}

DateInputField.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string
}

function mapStateToProps (state) {
  return {...state.issues, templates: state.templates.templates}
}

export default connect(mapStateToProps, {
  getIssuesAction,
  endDateChangeAction,
  startDateChangeAction,
  deleteIssueAction,
  updateIssueStatus,
  updateIssueAction
})(IssuesOverview)



// WEBPACK FOOTER //
// ./src/pages/issues/overview/index.js